import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import en from '../i18n/en'
import hi from '../i18n/hi'
import mr from '../i18n/mr'
import { api } from '@services/enhancedApiService'

const translations = { en, hi, mr }

export const LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'mr', label: 'Marathi', nativeLabel: 'मराठी' }
]

const I18nContext = createContext({ t: (key) => key, locale: 'en', setLocale: () => {} })

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => localStorage.getItem('x3algo_locale') || 'en')

  // Load from server on mount
  useEffect(() => {
    api.get('/user/language-preference').then(res => {
      const lang = res.data?.data?.language
      if (lang && translations[lang]) {
        setLocaleState(lang)
        localStorage.setItem('x3algo_locale', lang)
      }
    }).catch(() => {})
  }, [])

  const setLocale = useCallback((code) => {
    if (!translations[code]) return
    setLocaleState(code)
    localStorage.setItem('x3algo_locale', code)
    // Debounced save to server
    api.put('/user/language-preference', { language: code }).catch(() => {})
  }, [])

  const t = useCallback((key, fallback) => {
    return translations[locale]?.[key] || translations.en[key] || fallback || key
  }, [locale])

  return (
    <I18nContext.Provider value={{ t, locale, setLocale, LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  )
}

export function useI18n() {
  return useContext(I18nContext)
}

export default I18nContext
